import notify from 'boot/notify'
import fullscreen from 'boot/fullscreen'
import loading from 'boot/loading'
import platform from 'boot/platform'
import { setVueContext } from 'src/common/context'

const $helpers = {
  platform,
  loading,
  fullscreen,
  notify: notify.notify,
}

export default {
  install(app) {
    app.config.globalProperties.$helpers = $helpers
    setVueContext(app)
  },
}
